























import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class AppFormItem extends Vue {
  @Prop(String) readonly label!: string;
  @Prop({ type: [Number, String], default: '100' }) readonly width!:
    | number
    | string;

  @Prop(String) readonly hint!: string;
  @Prop({ type: Boolean, default: false }) readonly required!: boolean;
  @Prop(String) readonly color!: string;
  @Prop({ type: Boolean, default: false }) readonly showhint!: boolean;
}
